/**
 * continuousAnalyticalLayer.ts
 *
 * Which DEM-derived continuous colour overlay is draped on the terrain
 * surface. Mutually exclusive with each other (and, when active, replaces
 * the base imagery/neutral terrain colour) — additive overlays like
 * hillshade and contours can still combine on top.
 */

export enum ContinuousAnalyticalLayer {
  None = "none",
  Elevation = "elevation",
  Slope = "slope",
  Curvature = "curvature",
  LocalRelief = "localRelief",
}

/** Maps to terrainFragment.glsl's u_continuousLayerMode (0-4). */
const CONTINUOUS_LAYER_MODE_INDEX: Record<ContinuousAnalyticalLayer, number> = {
  [ContinuousAnalyticalLayer.None]: 0,
  [ContinuousAnalyticalLayer.Elevation]: 1,
  [ContinuousAnalyticalLayer.Slope]: 2,
  [ContinuousAnalyticalLayer.Curvature]: 3,
  [ContinuousAnalyticalLayer.LocalRelief]: 4,
};

export function continuousLayerModeToShaderIndex(layer: ContinuousAnalyticalLayer): number {
  return CONTINUOUS_LAYER_MODE_INDEX[layer];
}
